import React, { lazy, Suspense } from 'react';
import CWOConfigProvider from 'helpers/cwoConfigProvider';
import Loading from 'helpers/loading/loading';

const Component =
  lazy(() => import('components/agri-work-plan-new-design/pages/edit-agro-operations'));

const AgriWorkPlanFormEditAgroOperationsNewDesign = (props) => (
  <CWOConfigProvider>
    <Suspense fallback={<Loading />}>
      <Component {...props} />
    </Suspense>
  </CWOConfigProvider>
);

export default AgriWorkPlanFormEditAgroOperationsNewDesign;
